'use client';

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import ProductModal from '@/components/ProductModal';
import type { Product } from '@/components/ProductsSection';

const allProducts: Product[] = [
  { name: 'PENTAWIN-DSR', composition: 'Pantoprazole 40 mg + Domperidone 30 mg', category: 'Gastrointestinal Care', categoryId: 'GASTROINTESTINAL', image: '/assets/images/5993de82-5b09-4844-bad8-8e869708a6ca-1789056112530.jpeg' },
  { name: 'EWINCET-O', composition: 'Cefixime 200 mg + Ofloxacin 200 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/34cf7b16-b104-446b-90ee-60f0fa162f7b-1789051227451.jpeg' },
  { name: 'EPOD-50 CV', composition: 'Cefpodoxime 50 mg + Potassium Clavulanate 31.25 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/714de328-69a6-4b49-9843-a0ceb6f36dae-1789051422401.jpeg' },
  { name: 'EPOD-100', composition: 'Cefpodoxime 100 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/72cd4d9d-e37e-41af-a1c6-6db4d19a6c09-1789051422355.jpeg' },
  { name: 'EPOD-200', composition: 'Cefpodoxime Proxetil 200 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/72cd4d9d-e37e-41af-a1c6-6db4d19a6c09-1789051422355.jpeg' },
  { name: 'EWICLAV-625', composition: 'Amoxicillin 500 mg + Potassium Clavulanate 125 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/612f7449-3ed4-4b5f-99dd-3fa958ae9888-1789051192629.jpeg' },
  { name: 'EWICLAV-CV', composition: 'Amoxicillin + Potassium Clavulanate', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/612f7449-3ed4-4b5f-99dd-3fa958ae9888-1789051192629.jpeg', form: 'Pediatric Dry Syrup' },
  { name: 'EWIN-SP', composition: 'Aceclofenac 100 mg + Paracetamol 325 mg + Serratiopeptidase 15 mg', category: 'Pain & Inflammation', categoryId: 'PAIN-INFLAMMATION', image: '/assets/images/2aea4275-b920-42a1-833c-9c210144e5da-1789051422389.jpeg' },
  { name: 'EWINDROT', composition: 'Dicyclomine HCl 20 mg + Paracetamol 500 mg', category: 'Antispasmodic', categoryId: 'ANTISPASMODIC', image: '/assets/images/b239fd02-5f76-4015-82bd-80c9b03bd4e8-1789051422379.jpeg' },
  { name: 'LIVOMONT', composition: 'Levocetirizine 5 mg + Montelukast 10 mg', category: 'Anti-Allergic', categoryId: 'ANTI-ALLERGIC', image: '/assets/images/98660145-df9d-4e9b-a1c5-f211a89eb0de-1789051227432.jpeg' },
  { name: 'EWINCOF-D', composition: 'Dextromethorphan + Phenylephrine + CPM', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/649ddd64-b00a-4fc0-9305-6c7f7ef7a7a1-1789051422349.jpeg' },
  { name: 'EWINCOF-PD', composition: 'Levosalbutamol + Ambroxol + Guaiphenesin', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/c73fca46-0f1b-41fc-b9bb-8f27fdb2c14b-1789051227455.jpeg' },
  { name: 'EWIN-COF', composition: 'Bromhexine + Guaiphenesin + Terbutaline + Menthol', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/4d51e924-672f-4e77-a47d-651759648350-1789056112541.jpeg' },
  { name: 'EWIN-COLD', composition: 'Cetirizine 5 mg + Phenylephrine 5 mg + Paracetamol 325 mg', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/fbab4448-f423-47bb-86a7-62c817649a3d-1789051227458.jpeg' },
  { name: 'ELIV-DS', composition: 'Liver Tonic', category: 'Liver Care', categoryId: 'LIVER-CARE', image: '/assets/images/72c09661-aec8-4e20-8483-27ff9f5e2fc8-1789056112554.jpeg' },
  { name: 'MERCY', composition: 'Lactobacillus rhamnosus + Lactobacillus reuteri', category: "Probiotic / Women's Health", categoryId: 'PROBIOTIC', image: '/assets/images/0c36f435-9f2c-493f-b447-3f3e85a80086-1789056112520.jpeg' },
];

const categories = [
  { id: 'ALL', label: 'All Products' },
  { id: 'ANTI-INFECTIVE', label: 'Anti-Infective' },
  { id: 'RESPIRATORY', label: 'Respiratory' },
  { id: 'PAIN-INFLAMMATION', label: 'Pain & Inflammation' },
  { id: 'GASTROINTESTINAL', label: 'Gastrointestinal' },
  { id: 'ANTI-ALLERGIC', label: 'Anti-Allergic' },
  { id: 'ANTISPASMODIC', label: 'Antispasmodic' },
  { id: 'LIVER-CARE', label: 'Liver Care' },
  { id: 'PROBIOTIC', label: "Probiotic / Women\'s Health" },
];

export default function ProductsPageContent() {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const filtered = activeCategory === 'ALL'
    ? allProducts
    : allProducts.filter((p) => p.categoryId === activeCategory);

  return (
    <>
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Filters */}
          <div className="flex flex-wrap gap-2 justify-center mb-12">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`category-filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Count */}
          <div className="mb-8 flex items-center justify-between">
            <p className="text-sm text-muted-foreground">
              Showing <span className="font-semibold text-foreground">{filtered.length}</span> product{filtered.length !== 1 ? 's' : ''}
              {activeCategory !== 'ALL' && (
                <span> in <span className="font-semibold text-primary">{categories.find((c) => c.id === activeCategory)?.label}</span></span>
              )}
            </p>
            {activeCategory !== 'ALL' && (
              <button
                onClick={() => setActiveCategory('ALL')}
                className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M2 7H12M7 2L12 7L7 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                View All
              </button>
            )}
          </div>

          {/* Products Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((product) => (
              <div key={product.name} className="product-card flex flex-col">
                {/* Image */}
                <div className="bg-gradient-to-b from-slate-50 to-blue-50 flex items-center justify-center p-6 flex-shrink-0">
                  <AppImage
                    src={product.image}
                    alt={`${product.name} pharmaceutical product creative`}
                    width={300}
                    height={300}
                    className="object-contain w-full h-auto max-h-[260px]"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  />
                </div>
                {/* Info */}
                <div className="p-5 flex flex-col flex-1 gap-2">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-secondary">{product.category}</span>
                  <h3 className="font-display text-foreground text-lg leading-tight break-words">{product.name}</h3>
                  {product.form && (
                    <span className="text-xs text-muted-foreground italic">{product.form}</span>
                  )}
                  <p className="text-muted-foreground text-sm leading-relaxed flex-1">{product.composition}</p>
                  <button
                    onClick={() => setSelectedProduct(product)}
                    className="mt-3 pharma-btn-primary w-full justify-center text-sm"
                  >
                    View Product
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20 text-muted-foreground">
              No products found in this category.
            </div>
          )}
        </div>
      </section>

      {selectedProduct && (
        <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />
      )}
    </>
  );
}